var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import styled from "../../themes/styled";
import Box from "../../box/Box";
import Text from "../../text/Text";
import { MdAdd, MdRemove } from "react-icons/md";
import { themeGet } from "@styled-system/theme-get";
import Icon from "../../icon/Icon";
import { hasValue } from "../field/utils";
import { add, inRange, isFinite, subtract } from "lodash-es";
import nextId from "react-id-generator";
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    input[type=\"number\"] {\n        border: none;\n        outline: none;\n        text-align: center;\n        font-size: ", "px;\n        font-weight: ", ";\n        font-family: ", ";\n    }\n    input[type=\"number\"]::-webkit-inner-spin-button,\n    input[type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n    input[type=\"number\"] {\n        -moz-appearance: textfield;\n    }\n"], ["\n    input[type=\"number\"] {\n        border: none;\n        outline: none;\n        text-align: center;\n        font-size: ", "px;\n        font-weight: ", ";\n        font-family: ", ";\n    }\n    input[type=\"number\"]::-webkit-inner-spin-button,\n    input[type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n    input[type=\"number\"] {\n        -moz-appearance: textfield;\n    }\n"])), themeGet("fontSizes.1"), themeGet("fontWeights.regular"), themeGet("fonts.primary"));
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    -webkit-touch-callout: none;\n    user-select: none;\n    background: ", ";\n    border: none;\n    border-radius: 4px;\n    height: 30px;\n    outline: none;\n\n    &:hover:not(:disabled),\n    &:focus:not(:disabled) {\n        background: ", ";\n    }\n\n    &:hover:not(:disabled) {\n        cursor: pointer;\n    }\n"], ["\n    -webkit-touch-callout: none;\n    user-select: none;\n    background: ", ";\n    border: none;\n    border-radius: 4px;\n    height: 30px;\n    outline: none;\n\n    &:hover:not(:disabled),\n    &:focus:not(:disabled) {\n        background: ", ";\n    }\n\n    &:hover:not(:disabled) {\n        cursor: pointer;\n    }\n"])), function (p) { return themeGet(p.disabled ? "colors.grays.0" : "colors.grays.2"); }, themeGet("colors.grays.3"));
var ScreenReaderOnly = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute !important;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    clip: rect(0, 0, 0, 0) !important;\n    white-space: nowrap !important;\n    border: 0 !important;\n"], ["\n    position: absolute !important;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    clip: rect(0, 0, 0, 0) !important;\n    white-space: nowrap !important;\n    border: 0 !important;\n"])));
var updateCount = function (fn) { return function (step, value) {
    return hasValue(value) ? fn(parseInt(value, 10), step) : step;
}; };
var increment = updateCount(add);
var decrement = updateCount(subtract);
var NumberField = (function (_super) {
    __extends(NumberField, _super);
    function NumberField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.htmlId = nextId("oui-form-field-id-");
        _this.handleChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, min = _a.min, max = _a.max;
            var numValue = parseInt(e.target.value, 10);
            if (isFinite(numValue)) {
                if (inRange(numValue, min, max + 1)) {
                    onChange(e);
                }
            }
            else {
                onChange(e);
            }
        };
        return _this;
    }
    NumberField.prototype.componentDidMount = function () {
        var _a = this.props, value = _a.value, min = _a.min, max = _a.max;
        if (hasValue(value) && !inRange(value, min, max + 1)) {
            console.error("The provided value (" + value + ") to NumberField is out of the min(" + min + ") / max(" + max + ") bounds");
        }
    };
    NumberField.prototype.render = function () {
        var _a = this.props, name = _a.name, value = _a.value, onChange = _a.onChange, step = _a.step, min = _a.min, max = _a.max, disabled = _a.disabled, error = _a.error, helperText = _a.helperText, _b = _a.label, label = _b === void 0 ? "Quantity" : _b, rest = __rest(_a, ["name", "value", "onChange", "step", "min", "max", "disabled", "error", "helperText", "label"]);
        var isDecrementDisabled = isFinite(value) ? parseInt(value, 10) <= min : false;
        var isIncrementDisabled = isFinite(value) ? parseInt(value, 10) >= max : false;
        return (React.createElement(Container, __assign({ minWidth: "100px" }, rest),
            React.createElement(Button, { type: "button", onClick: function () {
                    return onChange({
                        target: {
                            name: name,
                            value: decrement(step, value).toString(),
                        },
                    });
                }, disabled: isDecrementDisabled, "aria-label": "Decrease " + label },
                React.createElement(Icon, { icon: MdRemove })),
            React.createElement("label", null,
                React.createElement(ScreenReaderOnly, null, label),
                React.createElement("input", { id: this.htmlId, tabIndex: -1, type: "number", name: name, pattern: "\\d*", min: min, max: max, disabled: disabled, readOnly: true, value: value, onChange: this.handleChange, style: { width: 32, height: 32, userSelect: "none" }, "aria-describedby": error || helperText ? this.htmlId + "__helper-text" : undefined })),
            React.createElement(Button, { type: "button", onClick: function () {
                    return onChange({
                        target: {
                            name: name,
                            value: increment(step, value).toString(),
                        },
                    });
                }, disabled: isIncrementDisabled, "aria-label": "Increase " + label },
                React.createElement(Icon, { icon: MdAdd })),
            error || helperText ? (React.createElement(Text, { fontSize: 1, color: error ? "gameRed" : "grays.4", mt: 1, id: this.htmlId + "__helper-text", role: "alert" }, error ? error : helperText)) : null));
    };
    NumberField.defaultProps = {
        step: 1,
        min: -Infinity,
        max: Infinity,
    };
    return NumberField;
}(Component));
export default NumberField;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=NumberField.js.map